/**
 * EU-739 — teto de tempo do CLIENTE para o download da base por programa.
 * ESTRITAMENTE MENOR que todos os tetos internos da cadeia (BFF->Core 280s <
 * ALB 300s <= Core 300s — spec 080, §Cadeia de timeouts): o corte é sempre do
 * cliente, que é quem pinta o toast de erro. Empatar deixaria indeterminado
 * quem corta primeiro e o SPA poderia ficar pendurado.
 */
export const EXPORT_TIMEOUT_MS = 240_000;
